export default "__VITE_ASSET__1a515d6e__"